import { render, staticRenderFns } from "./customerOrderStatistic.vue?vue&type=template&id=6c9a4758&scoped=true"
import script from "./customerOrderStatistic.vue?vue&type=script&lang=js"
export * from "./customerOrderStatistic.vue?vue&type=script&lang=js"
import style0 from "./customerOrderStatistic.vue?vue&type=style&index=0&id=6c9a4758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a4758",
  null
  
)

export default component.exports